import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3f5d291d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "course-swiper"
};
const _hoisted_2 = ["href"];
import { getImgUrl } from '@/utils/common';
export default {
  __name: 'index',
  props: {
    bannerImgs: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_carousel, {
        height: "350px"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.bannerImgs, img => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: img
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              href: img === null || img === void 0 ? void 0 : img.courseLink,
              target: "_blank"
            }, [_createVNode(_component_el_image, {
              class: "course-img",
              src: img.document ? _unref(getImgUrl)(img.document) : ''
            }, null, 8, ["src"])], 8, _hoisted_2)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]);
    };
  }
};